import React, { useState, useEffect } from 'react';

const $ = window.$;

export function PartnerHomeCalculatorTab(props) {
    useEffect(() => {
        console.log('#### useEffect PartnerHomeCalculatorTab');

        const price = new Intl.NumberFormat('en-US', {
            useGrouping: true,
        }).format(props.definedPropertyPrice.value);

        console.log('definedPropertyPrice: ' + props.definedPropertyPrice.value);
        document.getElementById('txtCalLoanAmount').value = price;
    }, []);

    function validateMaxMin(e) {
        window.validateMaxMin(e.target);
    }

    function tabClick(tab, e) {
        props.onTabClick(tab);
    }

    return (
        <div id="jmt-calculator-container" className="icw theme-h2c garage-npa-style jmt-calculator-container">
            <div className="garage-container">
                <section id="calculators-1" className="sc sc-calculator fx-section" data-dl-section="calculator-1">
                <div className="sc-inner">
                    <div className="sc-container container">

                    <h2 className="h1 mb-30">คำนวณวงเงินกู้<br className="visible-w375" />สินเชื่อบ้าน เบื้องต้น</h2>

                    <div className="calculate-container">
                        <div className="container-calculate">
                            <div className="wrapper-target">
                                <div className="title-target">วัตถุประสงค์การกู้ :</div>
                                <ul className="nav nav-tabs wrapper-tab" id="jmtMyTab" role="tablist">
                                    <li role="presentation">
                                        <button id="jmtCalForStayButton" className={'nav-link btn-tab active'} type="button" role="tab" aria-controls="for-stay" aria-selected="true" onClick={tabClick.bind(this, 'stay')}>
                                            <i className="ic-npa ic-npa-icon-house"></i>
                                            <span data-kbct="tab_content" data-kblb="home" data-kbgp="loan_for" data-kbsc="calculate" data-kbid={props.propertyId} >เพื่ออยู่อาศัย</span>
                                        </button>
                                    </li>
                                    <li role="presentation">
                                        <button id="jmtCalForBusinessButton" className={'nav-link btn-tab'} type="button" role="tab" aria-controls="for-business" aria-selected="false" onClick={tabClick.bind(this, 'business')}>
                                            <i className="ic-npa ic-npa-icon-business"></i>
                                            <span data-kbct="tab_content" data-kblb="business" data-kbgp="loan_for" data-kbsc="calculate" data-kbid={props.propertyId}>เพื่อธุรกิจ</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="sc-content">
                        <div className="sc-calculator-container form">
                        <fieldset>
                            <div className="fields">
                            <div className="row">
                                <div className="col-sm-6">
                                <div className="field">
                                    <label className="font-body"><strong>อาชีพ</strong></label>
                                    <div className="input border-bottom">
                                    <div className="select">
                                        <select data-placeholder="เลือกอาชีพ" className="select2" id="selCalOccupation" defaultValue="">
                                            <option value="" disabled>เลือกอาชีพ</option>
                                            <option value="1">พนักงานประจำ</option>
                                            <option value="2">เจ้าของกิจการ</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                </div>

                                <div className="col-sm-6">
                                <div className="field">
                                    <label className="font-body"><strong>ประเภทของบ้าน</strong></label>
                                    <div className="input border-bottom">
                                    <div className="select" style={{pointerEvents: 'none'}}>
                                        <select id="selHouseType" data-placeholder="เลือกประเภทของบ้าน" className="select2" defaultValue="2" readOnly>
                                            <option value="" disabled>เลือกประเภทของบ้าน</option>
                                            <option value="1">บ้านมือ 1</option>
                                            <option value="2">บ้านมือ 2</option>
                                            <option value="3">ปลูกบ้าน บนที่ดินของตนเอง</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6">
                                <div className="field">
                                    <label className="font-body"><strong>อายุผู้กู้ (ปี)</strong></label>
                                    <div className="input border-bottom">
                                    {/* <!-- <input type="text" className="number-format a-right" inputMode="numeric" data-is-scoped="true"
                                        data-minimum="0" data-maximum="100"> --> */}
                                    <input type="text" className="number-format-2 a-right" id="txtCalAge" inputMode="numeric" onBlur={validateMaxMin}
                                        data-minimum="20" data-maximum="69" data-errmin="อายุของผู้กู้ต้องอยู่ระหว่าง 20 - 69 ปี" maxLength="2" data-errmax="อายุของผู้กู้ต้องอยู่ระหว่าง 20 - 69 ปี" />

                                    <p className="error-msg">กรุณาระบุอายุ 20 - 69 ปี</p>
                                    </div>
                                </div>
                                </div>

                                <div className="col-sm-6">
                                <div className="field">
                                    <label className="font-body"><strong>เป็นการกู้บ้านหลังที่</strong></label>
                                    <div className="input border-bottom">
                                    <div className="select">
                                        <select id="selCalHouseNo" style={{fontSize: "14px"}} data-placeholder="เลือกการกู้บ้านหลังที่" className="select2" defaultValue="">
                                            <option value="" disabled>เลือกการกู้บ้านหลังที่</option>
                                            <option value="1">บ้านหลังที่ 1</option>
                                            <option value="2">บ้านหลังที่ 2 (ผ่อนหลังที่ 1 มาแล้วไม่ถึง 2 ปี)</option>
                                            <option value="3">บ้านหลังที่ 2 (ผ่อนหลังที่ 1 มาแล้วตั้งแต่ 2 ปี ขึ้นไป)</option>
                                            <option value="4">บ้านหลังที่ 3 เป็นต้นไป</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                
                            </div>
                            
                            <div className="row">
                                <div className="col-sm-6">
                                <div className="field">
                                    <label className="font-body"><strong>รายได้สุทธิต่อเดือน (บาท)</strong></label>
                                    <div className="input border-bottom">
                                    {/* <!-- <input type="text" className="number-format a-right" inputMode="numeric" data-is-validate-min="true" data-minimum="15000"> --> */}
                                    <input type="text" className="number-format-2 a-right" id="txtCalIncome" inputMode="numeric"  onBlur={validateMaxMin} maxLength="9" data-minimum="15000" data-errmin="รายได้ต่อเดือนสุทธิต้องไม่ต่ำกว่า 15,000 บาท" />
                                    
                                    <p className="error-msg">กรุณาระบุรายได้ขั้นต่ำ 15,000 บาท</p>
                                    </div>
                                </div>
                                </div>

                                
                                <div className="col-sm-6">
                                <div className="field">
                                    <label className="font-body"><strong>ราคาซื้อขาย หรือ ราคาประเมินที่อยู่อาศัย</strong></label>
                                    <div className="input border-bottom">
                                    <input type="text" className="number-format-2 a-right" id="txtCalLoanAmount" maxLength="9" inputMode="numeric" onBlur={validateMaxMin} data-minimum="300000" data-maximum="20000000" data-errmin="กรุณาเพิ่มราคาซื้อขายหรือราคาประเมินที่อยู่อาศัย เนื่องจากราคาต่ำกว่าเกณฑ์ที่ทางธนาคารกำหนดไว้ (ขั้นต่ำ 300,000 บาท)" data-errmax="กรุณาเพิ่มราคาซื้อขายหรือราคาประเมินที่อยู่อาศัย เนื่องจากราคาต่ำกว่าเกณฑ์ที่ทางธนาคารกำหนดไว้ (สูงสุด 10,000,000 บาท)" />
                                    
                                    <p className="error-msg">วงเงินกู้ขั้นต่ำต้องไม่น้อยกว่า 300,000 บาท</p>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div className="row">
                                
                                <div className="col-sm-6">
                                <div className="field">
                                    <label className="font-body"><strong>ภาระหนี้ต่อเดือน (บาท)</strong></label>
                                    <div className="input border-bottom">
                                    {/* <!-- <input type="text" className="number-format a-right" inputMode="numeric" data-is-validate-min="true" data-minimum="15000"> --> */}
                                    <input type="text" className="number-format-2 a-right" inputMode="numeric"  id="txtCalObligation" maxLength="9" />
                                    
                                    <p className="error-msg">ภาระหนี้ที่ต้องระบุไม่เกิน xxxx บาท หรือเพิ่มรายได้ต่อเดือน</p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </fieldset>
                        </div>
                    </div>
                    </div>
                </div>


                    <a id="error-msg-toggle" href="#calculator-error-box" mfp-src="#calculator-error-box" className="open-popup-lightbox" style={{display: "none"}}></a>

                    <div id="calculator-error-box" className="garage-container mfp-hide">
                    <div className="garage-lightbox">
                        <a className="modal-dismiss"><i className="ic ic-close"></i></a>
                        <div className="entry-content">
                        <h3 id="txtErr">Error Msg.</h3>
                        </div>
                    </div>
                    </div>

                <div id="salary-error-box" className="garage-container theme-h2c mfp-hide">
                    <div className="garage-lightbox">
                    <a className="modal-dismiss"><i className="ic ic-close"></i></a>
                    <div className="entry-content">
                        <p className="h4 my-0 template">รายได้ต่อเดือนสุทธิต้องไม่ต่ำกว่า 15,000 บาท</p>
                    </div>
                    </div>
                </div>
                </section>

                <section id="calculators-2" className="sc sc-calculator-result fx-section" data-dl-section="calculator-2">
                <div className="sc-inner">
                    <div className="sc-container container">
                    <div className="sc-action a-center">
                        <a href="#calculators-2" className="btn pxtm-clickEvent" title="คำนวณ - calculator"  id="btnCalC"><strong>คำนวณ</strong></a>
                        <input type="hidden" id="hdDebtRate" />
                        <input type="hidden" id="hdMaxDuration" />
                        <input type="hidden" id="hdMinAmt" />
                        <input type="hidden" id="hdLVT" />
                        <input type="hidden" id="hdincomeXDebtBurden" />
                    </div>
                    <div className="sc-content" style={{display: "none"}}>

                        <p className="h2 mb-40 mb-767-20 a-center c-white">ผลการคำนวณ<br className="visible-w767" />วงเงินกู้เบื้องต้น</p>

                        <div className="form">
                        <fieldset>
                            <div className="fields">
                            <div className="row">
                                <div className="col col-md-6">
                                <div className="field">
                                    <label className="font-body"><strong>วงเงินกู้สูงสุด (บาท)</strong></label>
                                    <div className="input border-bottom">
                                    <input defaultValue="10,000,000" type="text" id="txtCalAmount" className="range-slider-binding number-format a-right" inputMode="numeric" />
                                    </div>
                                    <input type="text" id="barCalAmount" className="range-slider"
                                    data-extra-classes="u-range-slider u-range-slider-indicator u-range-slider-grid"
                                    data-type="single" data-grid="true" data-hide-from-to="false" data-min="1000000" data-max="100000000"
                                    data-from="10000000" data-grid-num="3" data-prettify-separator="," />
                                    <input type="hidden" id="hdCalAmount" defaultValue="0" />
                                </div>
                                </div>
                                <div className="col col-md-6">
                                <div className="field">
                                    <label className="font-body"><strong>ระยะเวลากู้ที่ต้องการ (ปี)</strong></label>
                                    <div className="input border-bottom">
                                    <input defaultValue="5" id="txtCalDuration" type="text" className="range-slider-step-binding number-format a-right" inputMode="numeric" />
                                    </div>
                                    <input type="text" id="barCalDuration" className="range-slider-step"
                                    data-extra-classes="u-range-slider u-range-slider-indicator u-range-slider-grid u-range-slider-step"
                                    data-type="single" data-grid="true" data-hide-from-to="false" data-min="5" data-max="30"
                                    data-from="5" data-step="5" data-grid-num="5" data-prettify-separator="," data-limit="30" data-popup-message="สามารถกู้ได้สูงสุดไม่เกิน 15 ปี หรือหาผู้กู้ร่วมเพื่อเพิ่มระยะเวลาการกู้" />
                                </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-md-12 a-center">
                                <label className="font-body"><strong>ยอดผ่อนต่อเดือน (บาท)</strong></label>
                                <p className="h1 c-white" id="cal-monthly-counter">38,500</p>
                                </div>
                            </div>
                            </div>
                        </fieldset>
                        </div>
                    </div>

                    <div className="tab-condition">
                        <p className="tab-condition-title"><strong>หมายเหตุ :</strong></p>
                        <ul>
                        <li>ผลการคำนวณเป็นการประเมินความสามารถในการกู้เบื้องต้นเท่านั้น ทั้งนี้ ผลการอนุมัติสินเชื่อเป็นไปตามหลักเกณฑ์และเงื่อนไขของธนาคาร</li>
                        </ul>
                    </div>
                    </div>
                </div>
                </section>
            </div>
        </div>
    );
}
